import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AuthState {
  isLoggedIn: boolean
  token: string | null
  email: string | null
}

const initialState: AuthState = {
  isLoggedIn: false,
  token: null,
  email: null,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      state.isLoggedIn = true
      state.email = action.payload
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
    },
    logout: (state) => {
      state.isLoggedIn = false
      state.token = null
      state.email = null
    },
  },
})

export const { login, logout, setToken } = authSlice.actions
export default authSlice.reducer
